import { z } from 'src/lib';
import { OperacionNOTESFields, OperacionNOTESParametroFields } from './fields';
import { FilePutFields } from 'src/pages/sistema/api/file-fields';
import { schemaStringObligatorio, schemaStringOpcional } from 'src/pages/sistema/types/types';
import { OpcionSiNo } from '../../adcm/hooks/useOpcionesGenericas';
import { Validar } from '../../adl/types/dto';

export const schemaOperacionNOTESParametroInsert = z.object({
  [OperacionNOTESParametroFields.Titulo]: z.string().min(1, 'El título es requerido'),
  [OperacionNOTESParametroFields.Valor]: z.string().min(1, 'El valor es requerido'),
  [OperacionNOTESParametroFields.Orden]: z.number()
});

const notesBooleanTransform = (valor: any) => {
  if (typeof valor === 'boolean') return valor;
  if (valor === OpcionSiNo.Si) return true;
  if (valor === OpcionSiNo.No) return false;
  return null;
};

const schemaBooleanNOTES = z.preprocess(notesBooleanTransform, z.boolean({
  invalid_type_error: "Requerido"
}));

export const schemaOperacionNOTESInsert = z.object({
  [OperacionNOTESFields.CodPais]: z.number(),
  [OperacionNOTESFields.NombrePais]: schemaStringObligatorio,
  [OperacionNOTESFields.CodUnidadNegocio]: z.number(),
  [OperacionNOTESFields.CodSectorComercial]: z.number(),
  [OperacionNOTESFields.FechaSolicitud]: z.date(),

  [OperacionNOTESFields.TipoNota]: schemaStringObligatorio,
  [OperacionNOTESFields.CapitalASuscribir]: schemaStringObligatorio,
  [OperacionNOTESFields.Moneda]: schemaStringObligatorio,
  [OperacionNOTESFields.Vencimiento]: schemaStringObligatorio,
  [OperacionNOTESFields.FechaEmision]: z.date(),
  [OperacionNOTESFields.Emisor]: schemaStringObligatorio,
  [OperacionNOTESFields.Subyacentes]: schemaStringObligatorio,
  [OperacionNOTESFields.ObsSubyacentes]: schemaStringObligatorio,

  [OperacionNOTESFields.Cupon]: schemaStringOpcional,
  [OperacionNOTESFields.FrecuenciaPago]: schemaStringOpcional,
  [OperacionNOTESFields.CondicionPago]: schemaStringOpcional,
  [OperacionNOTESFields.ObsCupon]: schemaStringOpcional,

  [OperacionNOTESFields.Participacion]: schemaStringOpcional,
  [OperacionNOTESFields.FormaParticipacion]: schemaStringOpcional,
  [OperacionNOTESFields.DescripcionParticipacion]: schemaStringOpcional,
  [OperacionNOTESFields.ObsParticipacion]: schemaStringOpcional,


  [OperacionNOTESFields.TipoProteccion]: schemaStringObligatorio,
  [OperacionNOTESFields.NivelProteccion]: schemaStringObligatorio,
  [OperacionNOTESFields.DescripcionProteccion]: schemaStringObligatorio,
  [OperacionNOTESFields.ObsProteccion]: schemaStringOpcional,
  
  [OperacionNOTESFields.BarreraRescateAnticipado]: schemaStringOpcional,
  [OperacionNOTESFields.CondicionRescateAnticipado]: schemaStringOpcional,
  [OperacionNOTESFields.FrecuenciaObservacion]: schemaStringOpcional,
  [OperacionNOTESFields.ObsRescateAnticipado]: schemaStringOpcional,

  [OperacionNOTESFields.TieneCupon]: schemaBooleanNOTES,
  [OperacionNOTESFields.TieneParticipacion]: schemaBooleanNOTES,
  [OperacionNOTESFields.TieneRescateAnticipado]: schemaBooleanNOTES,

  [OperacionNOTESFields.ArchivoGrafico]: z.string().nullable().optional(),
  [FilePutFields.File]: z.instanceof(File).optional().nullable(),

  [OperacionNOTESFields.Parametros]: z.array(schemaOperacionNOTESParametroInsert)
}).superRefine((data, ctx) => {

  if (data[OperacionNOTESFields.TieneCupon] === true) {
    if (!data[OperacionNOTESFields.Cupon]?.trim()) {
      Validar(ctx, OperacionNOTESFields.Cupon, "El cupón es requerido");
    }
    if (!data[OperacionNOTESFields.FrecuenciaPago]?.trim()) {
      Validar(ctx, OperacionNOTESFields.FrecuenciaPago, "La frecuencia de pago es requerida");
    }
    if (!data[OperacionNOTESFields.CondicionPago]?.trim()) {
      Validar(ctx, OperacionNOTESFields.CondicionPago, "La condición de pago es requerida");
    }
  }

  if (data[OperacionNOTESFields.TieneRescateAnticipado] === true) {
    if (!data[OperacionNOTESFields.BarreraRescateAnticipado]?.trim()) {
      Validar(ctx, OperacionNOTESFields.BarreraRescateAnticipado);
    }
    if (!data[OperacionNOTESFields.CondicionRescateAnticipado]?.trim()) {
      Validar(ctx, OperacionNOTESFields.CondicionRescateAnticipado);
    }
    if (!data[OperacionNOTESFields.FrecuenciaObservacion]?.trim()) {
      Validar(ctx, OperacionNOTESFields.FrecuenciaObservacion);
    }
  }

  if (data[OperacionNOTESFields.TieneParticipacion] === true) {
  if (!data[OperacionNOTESFields.Participacion]?.trim()) {
    Validar(ctx, OperacionNOTESFields.Participacion);
  }
  if (!data[OperacionNOTESFields.FormaParticipacion]?.trim()) {
    Validar(ctx, OperacionNOTESFields.FormaParticipacion);
  }
  if (!data[OperacionNOTESFields.DescripcionParticipacion]?.trim()) {
    Validar(ctx, OperacionNOTESFields.DescripcionParticipacion);
  }
}

});

export const schemaOperacionNOTESParametroView = z.object({
  id: z.number(),
  [OperacionNOTESParametroFields.Titulo]: z.string(),
  [OperacionNOTESParametroFields.Valor]: z.string(),
  [OperacionNOTESParametroFields.Orden]: z.number().nullable()
});

export type OperacionNOTESInsert = z.infer<typeof schemaOperacionNOTESInsert>;
export type OperacionNOTESParametroInsert = z.infer<typeof schemaOperacionNOTESParametroInsert>;
export type OperacionNOTESParametroView = z.infer<typeof schemaOperacionNOTESParametroView>;